export const shouldEnableCustomerAccessForArticle = (userHasAccess: boolean, paywall: { enabled: boolean; access: boolean }): boolean => {
  return paywall.enabled && userHasAccess && !paywall.access;
};

export const shouldDisableCustomerAccessForArticle = (userHasAccess: boolean, paywall: { enabled: boolean; access: boolean }): boolean => {
  return paywall.enabled && !userHasAccess && paywall.access;
};
